import { FC, useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import AuthWrapper from '../../common/AuthWrapper';

import styles from './CreateNewPassword.module.scss';
import CustomPassInput from '../../common/CustomPassInput';
import CustomButton from '../../common/CustomButton';
import { useIsMobile } from '../../hooks/useWindowWidth';
import { useResetPasswordMutation } from '../../store/services/authApi';

const CreateNewPassword: FC = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [resetPassToken, setResetPassToken] = useState<string | null>(null);
  const [resetPasswordMutation] = useResetPasswordMutation();

  const [resErrors, setResErrors] = useState<{attr: string | null, code: string, detail: string}[] | null>(null);

  const token = localStorage.getItem('resetPassToken');

   useEffect(() => {
    if (token) {
      setResetPassToken(token);
    }
  }, [token]);

  const initialValues = {
    password: '',
    confirmPassword: '',
  };

  const handleSubmit = async (values: { confirmPassword: string; password: string }) => {
    console.log('CreateNewPassword in with:', values);

    try {
      await resetPasswordMutation({token: resetPassToken , password: values.password});
      navigate('/login');
      setResErrors(null);
    } catch (error) {
      console.error(error);
      setResErrors((error as any)?.data?.errors || null);
    }
  };

  const formikValidate = (values: { confirmPassword: string; password: string }) => {
    const errors: { confirmPassword?: string; password?: string } = {};
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[^\s]{8,}$/;

    if (!values.password) {
      errors.password = 'Password can\'t be empty';
    }
    if (!values.confirmPassword) {
      errors.confirmPassword = 'Password can\'t be empty';
    } else if (values.password.length <= 8) {
      errors.password = 'Password length should be at least 8 characters';
    } else if (!passwordRegex.test(values.password)) {
      errors.password = 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character';
    }
    if (!values.confirmPassword) {
      errors.confirmPassword = 'Password can\'t be empty';
    }
    if (values.password !== values.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    return errors;
  }

  return (
    <AuthWrapper btnName='Sign In'>
      <Box className={styles.newPassContent}>
        <Typography variant={`${isMobile ? 'h6Bold' : 'h5Bold'}`} className={styles.title}>Set new password</Typography>
        <Formik
          initialValues={initialValues}
          validate={formikValidate}
          onSubmit={handleSubmit}
        >
          {({ errors, handleChange, isSubmitting }) => (
            <Form className={styles.loginForm}>
              
              <CustomPassInput
                label='Create Password'
                error={errors.password}
                customClass={styles.customInput}
                onChange={handleChange}
              />
              <CustomPassInput
                label='Confirm Password'
                name='confirmPassword'
                error={errors.confirmPassword}
                customClass={styles.customInput}
                onChange={handleChange}
              />

              <CustomButton
                btnType='submit'
                customClass={styles.customButton}
                disabled={isSubmitting}
              >
                Update password
              </CustomButton>

              {resErrors && resErrors.map((error, index) => (
                <Typography key={index} variant='h12' sx={{ color: '#C8102E' }}>
                  {error.detail}
                </Typography>
              ))}
            </Form>)}
        </Formik>

        <Box className={styles.signInQuestion}>
          <Typography variant='h11' className={styles.signInQuestionText}>Remembered your password?</Typography>
          <Link to='/' className={styles.signInLink}>
            <Typography variant='h11Semibold'>Login</Typography>
          </Link>
        </Box>
      </Box>
    </AuthWrapper>
  )
};

export default CreateNewPassword;
